import { withFormField } from '@gogame/form';

import PaymentDetails from './PaymentDetails';

export default withFormField({ vertical: true, padding: 0 })(PaymentDetails);
